var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button is-fill",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('b-icon',{attrs:{"icon":"plus"}}),_vm._v(" "),_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }